"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findFilterOptionsFromRows = exports.exportTable = void 0;
exports.getDataFromObjectField = getDataFromObjectField;
exports.makeRemoteSearchFromColumns = exports.getSearchedData = exports.getOrderedData = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.parse-float.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.array.reverse.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/esnext.string.replace-all.js");
var _jspdf = _interopRequireDefault(require("jspdf"));
var _jspdfAutotable = _interopRequireDefault(require("jspdf-autotable"));
var _luxon = require("luxon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
function descendingComparator(a, b, value) {
  // IF YOU CHANGE THIS FUNCTION, UPDATE THE README
  if (value(b) < value(a) || value(b) == null && value(a) != null) {
    return -1;
  }
  if (value(b) > value(a) || value(b) == null && value(a) != null) {
    return 1;
  }
  return 0;
}
function getComparator(order, value) {
  return order === 'desc' ? function (a, b) {
    return descendingComparator(a, b, value);
  } : function (a, b) {
    return -descendingComparator(a, b, value);
  };
}
var findFilterOptionsFromRows = function findFilterOptionsFromRows(data) {
  var columns = data.columns,
    mode = data.mode;
  var columnSelectFilterOptions = {};
  columns.forEach(function (column) {
    if (column.search === 'select') {
      if (Object.keys(column).includes('selectOptions')) {
        if (column.selectOptions == null) {
          return column.selectOptions;
        } else {
          columnSelectFilterOptions[column.title] = column.selectOptions.map(function (option) {
            var _a;
            return {
              value: option.value,
              label: (_a = option.label) !== null && _a !== void 0 ? _a : String(option.value).toString()
            };
          });
        }
      } else if (mode === 'list') {
        var rows = data.rows;
        columnSelectFilterOptions[column.title] = rows.filter(function (row) {
          return !!row;
        }).map(function (row) {
          return {
            value: String(column.value(row)).toString(),
            label: String(column.value(row)).toString()
          };
        });
        var deDupedOptions = [];
        var _loop_1 = function _loop_1(option) {
          if (!deDupedOptions.some(function (o) {
            return o.value === option.value;
          })) {
            deDupedOptions.push(option);
          }
        };
        for (var _i = 0, _a = columnSelectFilterOptions[column.title]; _i < _a.length; _i++) {
          var option = _a[_i];
          _loop_1(option);
        }
        columnSelectFilterOptions[column.title] = deDupedOptions;
      }
    }
  });
  return columnSelectFilterOptions;
};
/**
 * This function can be used to retrieve data from an object. Useful in the value prop of a MaterialTable column.
 *
 * For Example:
 *
 * ```
 * value = (row) => getDataFromObjectField(row, 'fieldName.subFieldName')
 * ```
 *
 * @param object A plain JavaScript object
 * @param field A dot delimited field name, (e.g. fieldName, fieldName.subFieldName, fieldName.subFieldName.subSubFieldName)
 * @returns The value of *object* at *field*
 */
exports.findFilterOptionsFromRows = findFilterOptionsFromRows;
function getDataFromObjectField(object, field) {
  // Retrieve the value of the cell (in case the field is a nested object)
  var remainingColumnField = field;
  var value = object;
  var indexOfPeriod = remainingColumnField.indexOf('.');
  while (indexOfPeriod !== -1) {
    // Get the substring and find the value
    var substring = remainingColumnField.substring(0, indexOfPeriod);
    remainingColumnField = remainingColumnField.substring(indexOfPeriod + 1);
    var nextValue = value[substring];
    if (typeof nextValue !== 'object') {
      throw new Error("No more fields to retrieve from ".concat(field));
    }
    value = nextValue;
    indexOfPeriod = remainingColumnField.indexOf('.');
  }
  return value != null ? value[remainingColumnField] : null;
}
function getRangeSearch(searchTerm, column, row) {
  var searchValue = searchTerm.searchValue;
  // Prioritize custom search over default
  if (column === null || column === void 0 ? void 0 : column.customSearch) {
    if (column === null || column === void 0 ? void 0 : column.customSearch({
      min: parseFloat(searchValue[0]),
      max: parseFloat(searchValue[1])
    }, row)) {
      return true;
    }
  }
  // Handle default search
  return (searchValue[0] === '' || parseFloat(searchValue[0]) <= parseFloat(String(column.value(row))) || searchValue[0] == null) && (searchValue[1] === '' || parseFloat(searchValue[1]) >= parseFloat(String(column.value(row))) || searchValue[1] == null);
}
/**
 * A simplistic, case insensitive, generic search function.
 * @param searchTerm A value to compare against
 * @param valueToCheck The value being checked
 * @returns Whether or not valueToCheck includes searchTerm
 */
function defaultLocalDataComparator(searchTerm, valueToCheck) {
  var _a, _b, _c;
  if (typeof valueToCheck === 'boolean' && ((_b = (_a = valueToCheck.toString()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase()))) {
    return true;
  } else if (typeof valueToCheck === 'number' && valueToCheck.toString().includes(searchTerm)) {
    return true;
  } else if (typeof valueToCheck === 'string' && ((_c = valueToCheck.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase()))) {
    return true;
  } else {
    return false;
  }
}
function getColumnSearch(searchTerms, column, row) {
  if (searchTerms[column.title] == null || searchTerms[column.title] === undefined) {
    return true;
  }
  var searchValue = searchTerms[column.title].searchValue;
  if (typeof searchValue !== 'string') {
    return true;
  }
  // Prioritize a custom search over the default one
  else if (column === null || column === void 0 ? void 0 : column.customSearch) {
    if (column === null || column === void 0 ? void 0 : column.customSearch(searchValue, row)) {
      return true;
    }
  }
  // Otherwise, return the default search
  else {
    var value = column.value(row);
    if (value != null) {
      return defaultLocalDataComparator(searchValue, value);
    }
  }
}
function getSelectSearch(searchTerm, column, row) {
  if (searchTerm.searchValue == null || searchTerm.searchValue.length === 0) {
    return true;
  }
  // Prioritize a custom search over the default one
  else {
    var customSearch_1 = column.customSearch;
    if (customSearch_1) {
      if (searchTerm.searchValue.some(function (searchTerm) {
        return customSearch_1(searchTerm, row);
      })) {
        return true;
      }
    }
    // Otherwise, return the default search
    else {
      var value = column.value(row);
      var searchValue = searchTerm.searchValue;
      if (value != null) {
        return searchValue.includes(String(value).toString());
      }
    }
  }
  return false;
}
function getDateSearch(searchTerm, column, row) {
  if (searchTerm.searchValue == null) {
    return true;
  }
  // Prioritize a custom search over the default one
  else {
    var customSearch = column.customSearch;
    if (customSearch) {
      if (customSearch(searchTerm.searchValue, row)) {
        return true;
      }
    }
    // Otherwise, return the default search
    else {
      var value = column.value(row);
      if (_luxon.DateTime.isDateTime(value)) {
        if (searchTerm.searchValue.contains(value)) {
          return true;
        }
      }
    }
  }
  return false;
}
// Manipulate data according to order index; Called for every display
var getOrderedData = function getOrderedData(dataToOrder, columnToOrderBy, orderDirection) {
  var sortedData = dataToOrder.slice();
  // Prioritize a custom sort over the default one
  if (columnToOrderBy === null || columnToOrderBy === void 0 ? void 0 : columnToOrderBy.customSort) {
    sortedData.sort(columnToOrderBy.customSort);
    if (orderDirection === 'desc') sortedData.reverse();
  }
  // Otherwise, return the default sort
  else if (typeof (columnToOrderBy === null || columnToOrderBy === void 0 ? void 0 : columnToOrderBy.value) === 'function' && Array.isArray(sortedData)) {
    sortedData.sort(getComparator(orderDirection, columnToOrderBy.value));
  }
  return sortedData;
};
// Manipulate data according to searches/filtering; Called for every display
exports.getOrderedData = getOrderedData;
var getSearchedData = function getSearchedData(dataToSearch, columnSearchTerms, searchTerm, columns) {
  var searchedData = dataToSearch.slice();
  // Check if the all filter has been applied
  var isSearchingGlobally = searchTerm != null && searchTerm !== '';
  return searchedData.filter(function (row) {
    var _a, _b;
    var globalSearchSatisfied = false;
    var allPerColumnSearchesSatisfied = true;
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
      var column = columns_1[_i];
      // Check if this column filter has been applied
      var isSearchingColumn = false;
      var searchEntry = columnSearchTerms[column.title];
      if (searchEntry == null) {
        isSearchingColumn = false;
      } else if (searchEntry.searchType === 'range' && (((_a = searchEntry.searchValue) === null || _a === void 0 ? void 0 : _a[0]) !== '' || ((_b = searchEntry.searchValue) === null || _b === void 0 ? void 0 : _b[1]) !== '')) {
        isSearchingColumn = true;
      } else if (searchEntry.searchType === 'column' && searchEntry.searchValue !== '') {
        isSearchingColumn = true;
      } else if (searchEntry.searchType === 'select' && searchEntry.searchValue.length !== 0) {
        isSearchingColumn = true;
      } else if (searchEntry.searchType === 'date' && searchEntry.searchValue != null) {
        isSearchingColumn = true;
      }
      // Perform column filter, if applicable
      if (isSearchingColumn) {
        switch (searchEntry.searchType) {
          case 'range':
            if (!getRangeSearch(searchEntry, column, row)) allPerColumnSearchesSatisfied = false;
            break;
          case 'column':
            if (!getColumnSearch(columnSearchTerms, column, row)) allPerColumnSearchesSatisfied = false;
            break;
          case 'select':
            if (!getSelectSearch(searchEntry, column, row)) allPerColumnSearchesSatisfied = false;
            break;
          case 'date':
            if (!getDateSearch(searchEntry, column, row)) allPerColumnSearchesSatisfied = false;
            break;
          default:
        }
      }
      // Perform all filter, if applicable
      if (isSearchingGlobally) {
        var columnSearchParam = {};
        columnSearchParam[column.title] = {
          searchType: 'column',
          searchValue: searchTerm
        };
        if (getColumnSearch(columnSearchParam, column, row)) {
          globalSearchSatisfied = true;
        }
      }
    }
    return (isSearchingGlobally && globalSearchSatisfied || !isSearchingGlobally) && allPerColumnSearchesSatisfied;
  });
};
exports.getSearchedData = getSearchedData;
var makeRemoteSearchFromColumns = function makeRemoteSearchFromColumns(columns, columnSearchTerms) {
  var where = {};
  for (var i = 0; i < columns.length; i++) {
    var columnTitle = columns[i].title;
    var remoteField = columns[i].remoteField;
    var searchEntry = columnSearchTerms[columnTitle];
    if (remoteField != null && searchEntry != null) {
      // Simple Search Box
      if (searchEntry.searchType === 'column') {
        var customSearch = columns[i].customSearch;
        if (customSearch) {
          where[remoteField] = customSearch(searchEntry.searchValue);
        } else {
          where[remoteField] = {
            $like: '%' + searchEntry.searchValue + '%'
          };
        }
      }
      // Float Range Search Boxes
      else if (searchEntry.searchType === 'range') {
        var searchValue = searchEntry.searchValue;
        var min = (searchValue === null || searchValue === void 0 ? void 0 : searchValue[0]) == null || (searchValue === null || searchValue === void 0 ? void 0 : searchValue[0]) === '' ? null : parseFloat(searchValue === null || searchValue === void 0 ? void 0 : searchValue[0]);
        var max = (searchValue === null || searchValue === void 0 ? void 0 : searchValue[1]) == null || (searchValue === null || searchValue === void 0 ? void 0 : searchValue[1]) === '' ? null : parseFloat(searchValue === null || searchValue === void 0 ? void 0 : searchValue[1]);
        var customSearch = columns[i].customSearch;
        if (customSearch) {
          where[remoteField] = customSearch({
            min: min !== null && min !== void 0 ? min : undefined,
            max: max !== null && max !== void 0 ? max : undefined
          });
        } else {
          if (min != null && max == null) {
            where[remoteField] = {
              $gte: min
            };
          } else if (max != null && min == null) {
            where[remoteField] = {
              $lte: max
            };
          } else if (min != null && max != null) {
            where[remoteField] = {
              $gte: min,
              $lte: max
            };
          }
        }
      } else if (searchEntry.searchType === 'select') {
        var customSearch = columns[i].customSearch;
        if (customSearch) {
          where[remoteField] = customSearch(searchEntry.searchValue);
        } else {
          where[remoteField] = {
            $in: searchEntry.searchValue
          };
        }
      } else if (searchEntry.searchType === 'date') {
        var customSearch = columns[i].customSearch;
        if (customSearch) {
          where[remoteField] = customSearch(searchEntry.searchValue);
        } else if (searchEntry.searchValue !== null) {
          where[remoteField] = {
            $between: [searchEntry.searchValue.start.toISO(), searchEntry.searchValue.end.toISO()]
          };
        }
      }
    }
  }
  return where;
};
exports.makeRemoteSearchFromColumns = makeRemoteSearchFromColumns;
var downloadBlob = function downloadBlob(blob, fileName) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (window.navigator.msSaveOrOpenBlob) {
    // IE10+ ... yuck
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    // Others
    var a_1 = document.createElement('a'),
      url_1 = URL.createObjectURL(blob);
    a_1.href = url_1;
    a_1.target = '_blank';
    a_1.rel = 'noreferrer';
    a_1.download = fileName;
    document.body.appendChild(a_1);
    var clickEvent = new MouseEvent('click', {
      ctrlKey: true
    });
    a_1.dispatchEvent(clickEvent);
    setTimeout(function () {
      document.body.removeChild(a_1);
      window.URL.revokeObjectURL(url_1);
    }, 0);
  }
};
var exportTable = function exportTable(data, fileType, columnSearchTerms, searchTerm, orderDirection, orderByIdx, tableTitle, onError, setIsDownloading) {
  return __awaiter(void 0, void 0, void 0, function () {
    var columnsToExport, headerRow, rawContent, _a, where, error_1, filteredData, fileName, bodyContent, pdfFile, escapedBodyContent, csvString, blob;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
      switch (_f.label) {
        case 0:
          if (!Array.isArray(data === null || data === void 0 ? void 0 : data.columns) && onError) {
            onError('The `downloadTable` function must be passed a `data.columns` array');
            return [2 /*return*/];
          }

          setIsDownloading === null || setIsDownloading === void 0 ? void 0 : setIsDownloading(true);
          columnsToExport = data.columns.filter(function (column) {
            return !column.omitFromExport;
          });
          headerRow = columnsToExport.filter(function (column) {
            return !column.omitFromExport;
          }).map(function (column) {
            return column.title;
          });
          _a = data === null || data === void 0 ? void 0 : data.mode;
          switch (_a) {
            case 'remote':
              return [3 /*break*/, 1];
            case 'list':
              return [3 /*break*/, 6];
          }
          return [3 /*break*/, 7];
        case 1:
          where = makeRemoteSearchFromColumns(data.columns, columnSearchTerms);
          _f.label = 2;
        case 2:
          _f.trys.push([2, 4,, 5]);
          return [4 /*yield*/, data.fetchRemoteData({
            order: [(_d = (_c = (_b = data.columns[orderByIdx]) === null || _b === void 0 ? void 0 : _b.customSort) === null || _c === void 0 ? void 0 : _c.call(_b, orderDirection)) !== null && _d !== void 0 ? _d : [(_e = data.columns[orderByIdx].remoteField) !== null && _e !== void 0 ? _e : 'id', orderDirection]],
            where: where
          })];
        case 3:
          rawContent = _f.sent().results;
          return [3 /*break*/, 5];
        case 4:
          error_1 = _f.sent();
          setIsDownloading === null || setIsDownloading === void 0 ? void 0 : setIsDownloading(false);
          alert('Error: Unable to download data');
          onError === null || onError === void 0 ? void 0 : onError(error_1);
          throw error_1;
        case 5:
          return [3 /*break*/, 8];
        case 6:
          {
            filteredData = getSearchedData(data.rows, columnSearchTerms, searchTerm, data.columns);
            rawContent = getOrderedData(filteredData, data.columns[orderByIdx], orderDirection);
            return [3 /*break*/, 8];
          }
          _f.label = 7;
        case 7:
          {
            onError === null || onError === void 0 ? void 0 : onError('The `downloadTable` function must be passed a `data.mode` of either "remote" or "list"');
            setIsDownloading === null || setIsDownloading === void 0 ? void 0 : setIsDownloading(false);
            return [2 /*return*/];
          }

          _f.label = 8;
        case 8:
          fileName = "".concat(tableTitle !== null && tableTitle !== void 0 ? tableTitle : "ExportedData [".concat(_luxon.DateTime.now().toFormat('yyyy-LL-dd'), "]"), ".").concat(fileType);
          switch (fileType) {
            case 'pdf':
              {
                bodyContent = rawContent.map(function (row) {
                  var _a, _b, _c, _d, _e;
                  var rowValues = [];
                  for (var i = 0; i < columnsToExport.length; i++) {
                    var value = columnsToExport[i].value(row);
                    var renderedValue = (_b = (_a = columnsToExport[i]).render) === null || _b === void 0 ? void 0 : _b.call(_a, row);
                    if (typeof renderedValue === 'string') {
                      value = renderedValue;
                    }
                    var rawStringValue = void 0;
                    if (typeof value === 'string') {
                      rawStringValue = value;
                    } else if (value == null) {
                      rawStringValue = '';
                    } else if (typeof value === 'object') {
                      rawStringValue = JSON.stringify(value, undefined, 2);
                    } else {
                      rawStringValue = (_e = (_d = (_c = value).toString) === null || _d === void 0 ? void 0 : _d.call(_c)) !== null && _e !== void 0 ? _e : 'undefined';
                    }
                    rowValues[i] = rawStringValue;
                  }
                  return rowValues;
                });
                pdfFile = new _jspdf.default({
                  orientation: 'landscape',
                  unit: 'px'
                });
                (0, _jspdfAutotable.default)(pdfFile, {
                  theme: 'striped',
                  head: [headerRow],
                  body: bodyContent,
                  styles: {}
                });
                downloadBlob(pdfFile.output('blob'), fileName);
                break;
              }
            case 'csv':
              {
                escapedBodyContent = rawContent.map(function (row) {
                  var _a, _b, _c, _d, _e;
                  var rowValues = [];
                  for (var i = 0; i < columnsToExport.length; i++) {
                    var value = columnsToExport[i].value(row);
                    var renderedValue = (_b = (_a = columnsToExport[i]).render) === null || _b === void 0 ? void 0 : _b.call(_a, row);
                    if (typeof renderedValue === 'string') {
                      value = renderedValue;
                    }
                    var rawStringValue = void 0;
                    if (typeof value === 'string') {
                      rawStringValue = value;
                    } else if (value == null) {
                      rawStringValue = '';
                    } else if (typeof value === 'object') {
                      rawStringValue = JSON.stringify(value, undefined, 2);
                    } else {
                      rawStringValue = (_e = (_d = (_c = value).toString) === null || _d === void 0 ? void 0 : _d.call(_c)) !== null && _e !== void 0 ? _e : 'undefined';
                    }
                    rowValues[i] = "\"".concat(rawStringValue.replaceAll('"', '\'').replaceAll('\n', '  '), "\"");
                  }
                  return rowValues;
                });
                csvString = [headerRow].concat(escapedBodyContent).map(function (row) {
                  return row.join(',');
                }).join('\n');
                blob = new Blob([csvString], {
                  type: 'text/csv'
                });
                downloadBlob(blob, fileName);
                break;
              }
            default:
              break;
          }
          setIsDownloading === null || setIsDownloading === void 0 ? void 0 : setIsDownloading(false);
          return [2 /*return*/];
      }
    });
  });
};
exports.exportTable = exportTable;